import { createRouter, createWebHistory } from 'vue-router'
import MainLayout from '@/components/layout/MainLayout.vue'
// 直接导入错误页面组件
import ErrorPage from '@/components/ErrorPage.vue'
import service from '@/utils/request'

// 简化的懒加载函数
function lazyLoad (viewPath) {
  return () =>
    import(/* @vite-ignore */ `@/views/${viewPath}`)
      .then(module => {
        // 加载成功，清除错误标记
        localStorage.removeItem('useErrorPage')
        localStorage.removeItem('refreshCount')
        return module
      })
      .catch(err => {
        console.error('路由加载错误:', err)
        // 设置错误标记
        localStorage.setItem('useErrorPage', 'true')
        // 简单的刷新策略
        const refreshCount = parseInt(localStorage.getItem('refreshCount') || '0')
        if (refreshCount < 2) {
          localStorage.setItem('refreshCount', (refreshCount + 1).toString())
          console.log('尝试刷新页面...')
          setTimeout(() => {
            window.location.reload()
          }, 200)
        } else {
          localStorage.removeItem('refreshCount')
          console.log('多次刷新后仍然失败，使用错误页面')
        }
        // 返回错误页面
        return ErrorPage
      })
}

// 路由配置保持不变
const routes = [
  {
    path: '/',
    component: MainLayout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: lazyLoad('dashboard/index.vue'),
        meta: { title: '仪表盘' }
      },
      {
        path: 'user',
        name: 'User',
        component: lazyLoad('user/index.vue'),
        meta: { title: '用户管理' }
      },
      {
        path: 'product',
        name: 'Product',
        component: lazyLoad('product/index.vue'),
        meta: { title: '产品管理' }
      },
      {
        path: 'activity',
        name: 'Activity',
        component: lazyLoad('activity/index.vue'),
        meta: { title: '动态管理' }
      },
      {
        path: 'setting',
        name: 'Setting',
        component: lazyLoad('setting/index.vue'),
        meta: { title: '系统设置' }
      }

      /*
      {
        path: 'setting',
        name: 'Setting',
        component: lazyLoad('setting/index.vue'),
        meta: { title: '系统设置' }
      }
      */
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('@/views/login/reset-password.vue'),
    meta: { requiresAuth: false }
  }
]

// createRouter 配置片段
const router = createRouter({
  history: createWebHistory(process.env.NODE_ENV === 'production' ? '/admin/' : '/'),
  routes
})

// 添加路由守卫
router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('token')

  if (token) {
    try {
      // 成功则说明 token 可用；失败会进入 catch
      await service.get('/auth/me')
    } catch (error) {
      localStorage.removeItem('token')
      if (to.path !== '/login') {
        next('/login')
        return
      }
    }
  }

  if (to.path !== '/login' && !localStorage.getItem('token')) {
    next('/login')
  } else if (to.path === '/login' && localStorage.getItem('token')) {
    next('/')
  } else {
    next()
  }
})

export default router
